import { AppType, BuildType, Environment } from '@domains';

export const environment: Environment = new Environment({
  production: true,
  app: AppType.DRIVER,
  buildType: BuildType.DEMO
});
